import { CalendarIcon } from "@mui/x-date-pickers-pro";
import FileSvg from "../../assets/svgs/FileSvg";
import { Icons } from "../../assets";
import { selectUser } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";


const useMenuOptions = () => {
  const user = useSelector(selectUser);
  const menuOptions = [
    {
      id: 1,
      name: "Command Center",
      path: "/",
      icon: Icons.Communities_Icon1,
      hasSubsections: true,
      access: user?.modules?.cc_home && user?.permissions?.includes('cc_home.view_cc_home'),
      disabled: !user?.modules?.cc_home || !user?.permissions?.includes('cc_home.view_cc_home'),
      subSections: [
        {
          id: 5,
          name: "Home",
          path: "/home",
          access: user?.modules?.cc_home && user?.permissions?.includes('cc_home.view_cc_home'),
          disabled: !user?.modules?.cc_home || !user?.permissions?.includes('cc_home.view_cc_home'),
        },
        {
          id: 6,
          name: "Calendar View",
          path: "/calendar-view",
          access: user?.modules?.calendar_view && user?.permissions?.includes('calendar_view.view_calendar_view'),
          disabled: !user?.modules?.calendar_view || !user?.permissions?.includes('calendar_view.view_calendar_view'),
        },
        {
          id: 7,
          name: "Dispatch",
          path: "/patient-assignment",
          access: user?.modules?.dispatch && user?.permissions?.includes('dispatch.view_dispatch'),
          disabled: !user?.modules?.dispatch || !user?.permissions?.includes('dispatch.view_dispatch'),
        },
        {
          id: 8,
          name: "Patient Panel Visualizer",
          path: "/patient-panel-visualizer",
          access: user?.modules?.patient_panel_visualizer && user?.permissions?.includes('patient_panel_visualizer.view_patient_panel_visualizer'),
          disabled: !user?.modules?.patient_panel_visualizer || !user?.permissions?.includes('patient_panel_visualizer.view_patient_panel_visualizer'),
        },
      ],
    },
    {
      id: 2,
      name: "Data Management",
      path: "/data-management",
      icon: Icons.Stats_Icon,
      hasSubsections: true,
      access: user?.modules?.data_management && user?.permissions?.includes('data_management.view_data_management'),
      disabled: !user?.modules?.data_management || !user?.permissions?.includes('data_management.view_data_management'),
      subSections: [
            {
              id: 6,
              name: "Providers",
              path: "/data-management/providers",
              access: user?.modules?.data_management?.provider && user?.permissions?.includes('providers_dm.view_providers'),
              disabled: !user?.modules?.data_management?.provider || !user?.permissions?.includes('providers_dm.view_providers'),
            },
            {
              id: 7,
              name: "Patients",
              path: "/data-management/patients",
              access: user?.modules?.data_management?.patient && user?.permissions?.includes('patients_dm.view_patients'),
              disabled: !user?.modules?.data_management?.patient || !user?.permissions?.includes('patients_dm.view_patients'),
            },
            {
              id: 8,
              name: "Communities",
              path: "/data-management/communities",
              access: user?.modules?.data_management?.communities && user?.permissions?.includes('communities_dm.view_communities'),
              disabled: !user?.modules?.data_management?.communities || !user?.permissions?.includes('communities_dm.view_communities'),
            },
            {
              id: 11,
              name: "Members",
              path: "/data-management/members",
              access: user?.modules?.data_management?.members && user?.permissions?.includes('members_dm.view_members'),
              disabled: !user?.modules?.data_management?.members || !user?.permissions?.includes('members_dm.view_members'),
            },
            // {
            //   id: 9,
            //   name: "Zones",
            //   path: "/data-management/zones",
            //   access: user?.modules?.data_management?.zones && user?.permissions?.includes('zones_dm.view_zones'),
            //   disabled: !user?.modules?.data_management?.zones || !user?.permissions?.includes('zones_dm.view_zones'),
            // },
            {
              id: 10,
              name: "Caretags",
              path: "/data-management/caretags",
              access: user?.modules?.data_management?.caretags && user?.permissions?.includes('caretags_dm.view_caretags'),
              disabled: !user?.modules?.data_management?.caretags || !user?.permissions?.includes('caretags_dm.view_caretags'),
            },
            {
              id: 12,
              name: "Referral Sources",
              path: "/data-management/referral-sources",
              access: user?.modules?.data_management?.referral_sources && user?.permissions?.includes('referral_sources_dm.view_referral_sources'),
              disabled: !user?.modules?.data_management?.referral_sources || !user?.permissions?.includes('referral_sources_dm.view_referral_sources'),
            },
          ],
    },
    {
      id: 3,
      name: "Messenger",
      path: "/chat",
      icon: Icons.Chat_Icon,
      access: user?.modules?.messenger && user?.permissions?.includes('messenger.view_messenger'),
      disabled: !user?.modules?.messenger || !user?.permissions?.includes('messenger.view_messenger'),
    },
    {
      id: 21,
      name: "Scheduler",
      path: "/schedules",
      icon: CalendarIcon,
      noIcon: true,
      hasSubsections: true,
      access: user?.modules?.scheduler_settings && user?.permissions?.includes('scheduler_settings.view_scheduler_settings'),
      disabled: !user?.modules?.scheduler_settings || !user?.permissions?.includes('scheduler_settings.view_scheduler_settings'),
      subSections: [
        {
          id: 0,
          name: "Data and Settings",
          access: user?.modules?.scheduler_settings?.data_and_settings && user?.permissions?.includes('scheduler_settings.data_settings.*'),
          hasSubsections: true,
          disabled: !user?.modules?.scheduler_settings?.data_and_settings || !user?.permissions?.includes('scheduler_settings.data_settings.*'),
          subSections: [
            {
              id: 2,
              name: "Provider Settings",
              path: "/schedules/configure/providers",
              access: user?.modules?.scheduler_settings?.data_and_settings?.provider_settings && user?.permissions?.includes('provider_settings.view_provider_settings'),
              disabled: !user?.modules?.scheduler_settings?.data_and_settings?.provider_settings || !user?.permissions?.includes('provider_settings.view_provider_settings'),
            },
            {
              id: 3,
              name: "Visit Rules",
              path: "/schedules/configure/visit-rules",
              access: user?.modules?.scheduler_settings?.data_and_settings?.visit_rules && user?.permissions?.includes('visit_rules.view_visit_rules'),
              disabled: !user?.modules?.scheduler_settings?.data_and_settings?.visit_rules || !user?.permissions?.includes('visit_rules.view_visit_rules'),
            },
            {
              id: 4,
              name: "Visit Types",
              path: "/schedules/configure/visit-types",
              access: user?.modules?.scheduler_settings?.data_and_settings?.visit_types && user?.permissions?.includes('visit_types.view_visit_types'),
              disabled: !user?.modules?.scheduler_settings?.data_and_settings?.visit_types || !user?.permissions?.includes('visit_types.view_visit_types'),
            },
            {
              id: 5,
              name: "Care Programs",
              path: "/schedules/configure/care-programs",
              access: user?.modules?.scheduler_settings?.data_and_settings?.care_programs && user?.permissions?.includes('care_programs.view_care_programs'),
              disabled: !user?.modules?.scheduler_settings?.data_and_settings?.care_programs || !user?.permissions?.includes('care_programs.view_care_programs'),
            },
            {
              id: 6,
              name: "Program Frequency",
              path: "/schedules/configure/program-frequency",
              access: user?.modules?.scheduler_settings?.data_and_settings?.program_frequency && user?.permissions?.includes('program_frequency.view_program_frequency'),
              disabled: !user?.modules?.scheduler_settings?.data_and_settings?.program_frequency || !user?.permissions?.includes('program_frequency.view_program_frequency'),
            },
            {
              id: 6,
              name: "Appointment Type Criteria",
              path: "/schedules/configure/appointment-type-criteria",
              access: user?.modules?.scheduler_settings?.data_and_settings?.appointment_type_criteria && user?.permissions?.includes('appointment_type_criteria.view_appointment_type_criteria'),
              disabled: !user?.modules?.scheduler_settings?.data_and_settings?.appointment_type_criteria || !user?.permissions?.includes('appointment_type_criteria.view_appointment_type_criteria'),
            },
            // {
            //   id: 1,
            //   name: "Upload Scheduling Data",
            //   path: "/schedules/careplan-upload",
            //   access: ["1"],
            // },
          ],
        },
        // {
        //   id: 5,
        //   name: "Run Scheduler",
        //   path: "/schedules/run-scheduler",
        //   access: ["1"],
        //   isEnterprise: false,
        // },
      ],
    },
    {
      id: 23,
      name: "Reporting & Analytics",
      path: "/reports",
      icon: FileSvg,
      noIcon: true,
      hasSubsections: true,
      access: user?.modules?.analytics_reporting && user?.permissions?.includes('reporting_analytics.view_reporting_analytics'),
      disabled: !user?.modules?.analytics_reporting || !user?.permissions?.includes('reporting_analytics.view_reporting_analytics'),
      subSections: [
        {
          id: 0,
          name: "Standard Reports",
          access: user?.modules?.analytics_reporting?.standard_reports && user?.permissions?.includes('standard_reports.view_standard_reports'),
          hasSubsections: true,
          disabled: !user?.modules?.analytics_reporting?.standard_reports || !user?.permissions?.includes('standard_reports.view_standard_reports'),
          subSections: [
            {
              id: 1,
              name: "Patient Visit Report",
              path: "/reports/patient-visit-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.patient_visit_report && user?.permissions?.includes('standard_reports.patient_visit_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.patient_visit_report || !user?.permissions?.includes('standard_reports.patient_visit_report.*'),
            },
            // {
            //   id: 2,
            //   name: "Provider Activity Report",
            //   path: "/reports/provider-activity-report",
            //   access: ["*"],
            // },
            // {
            //   id: 3,
            //   name: "Revenue Report",
            //   path: "/reports/revenue-report",
            //   access: user?.modules?.analytics_reporting?.standard_reports?.revenue_report && user?.permissions?.includes('standard_reports.revenue_report.*'),
            //   disabled: !user?.modules?.analytics_reporting?.standard_reports?.revenue_report || !user?.permissions?.includes('standard_reports.revenue_report.*'),
            // },
            {
              id: 4,
              name: "Appointment Cancellation Report",
              path: "/reports/appointment-cancellation-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.appointment_cancellation_report && user?.permissions?.includes('standard_reports.appointment_cancellation_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.appointment_cancellation_report || !user?.permissions?.includes('standard_reports.appointment_cancellation_report.*'),
            },
            {
              id: 5,
              name: "Overdue Patients Report",
              path: "/reports/overdue-patients-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.overdue_patients_report && user?.permissions?.includes('standard_reports.overdue_patients_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.overdue_patients_report || !user?.permissions?.includes('standard_reports.overdue_patients_report.*'),
            },
            {
              id: 6,
              name: "New Patients Report",
              path: "/reports/new-patients-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.new_patients_report && user?.permissions?.includes('standard_reports.new_patients_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.new_patients_report || !user?.permissions?.includes('standard_reports.new_patients_report.*'),
            },
            {
              id: 7,
              name: "Provider Daily Mileage Report",
              path: "/reports/provider-daily-mileage-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.provider_daily_mileage_report && user?.permissions?.includes('standard_reports.provider_daily_mileage_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.provider_daily_mileage_report || !user?.permissions?.includes('standard_reports.provider_daily_mileage_report.*'),
            },
            {
              id: 8,
              name: "No Show Report",
              path: "/reports/no-show-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.no_show_report && user?.permissions?.includes('standard_reports.no_show_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.no_show_report || !user?.permissions?.includes('standard_reports.no_show_report.*'),
            },
            {
              id: 9,
              name: "Patient Zip Code Report",
              path: "/reports/patient-zipcode-report",
              access: user?.modules?.analytics_reporting?.standard_reports?.patient_zipcode_report && user?.permissions?.includes('standard_reports.patient_zipcode_report.*'),
              disabled: !user?.modules?.analytics_reporting?.standard_reports?.patient_zipcode_report || !user?.permissions?.includes('standard_reports.patient_zipcode_report.*'),
            },
            // {
            //   id: 11,
            //   name: "Lucet Published Reports",
            //   path: "/reports/shared-reports",
            //   hasSubsections: true,
            //   access: ["1"],
            //   subSections: [
                
            //   ],
            // },
          ],
        },
        {
          id: 11,
          name: "Lucet Published Reports",
          access: user?.modules?.analytics_reporting?.published_reports && user?.permissions?.includes('reporting_analytics.view_published_reports'),
          hasSubsections: true,
          disabled: !user?.modules?.analytics_reporting?.published_reports || !user?.permissions?.includes('reporting_analytics.view_published_reports'),
          path: "/reports/shared-reports",
          subSections: [
          
          ],
        },
        {
          id: 12,
          name: "Lucet Published Dashboards",
          access: user?.modules?.analytics_reporting?.published_reports && user?.permissions?.includes('reporting_analytics.view_published_reports'),
          hasSubsections: true,
          disabled: !user?.modules?.analytics_reporting?.published_reports || !user?.permissions?.includes('reporting_analytics.view_published_reports'),
          path: "/dashboards/shared-dashboards",
          subSections: [
          
          ],
        },
        {
          id: 8,
          name: "Pivot",
          path: "/analytics/pivot",
          access: user?.modules?.analytics_reporting?.pivot && user?.permissions?.includes('reporting_analytics.pivot'),
          disabled: !user?.modules?.analytics_reporting?.pivot || !user?.permissions?.includes('reporting_analytics.pivot'),
        },
        {
          id: 7,
          name: "Report Builder",
          path: "/reports/report-builder",
          access: user?.modules?.analytics_reporting?.report_builder && user?.permissions?.includes('reporting_analytics.report_builder'),
          disabled: !user?.modules?.analytics_reporting?.report_builder || !user?.permissions?.includes('reporting_analytics.report_builder'),
        },
        {
          id: 9,
          name: "Dashboard Builder",
          path: "/analytics/dashboard",
          access: user?.modules?.analytics_reporting?.dashboard_builder && user?.permissions?.includes('reporting_analytics.dashboard_builder'),
          disabled: !user?.modules?.analytics_reporting?.dashboard_builder || !user?.permissions?.includes('reporting_analytics.dashboard_builder'),
        },
        {
          id: 10,
          name: "CareSMS-BI",
          path: "https://skorboard.com/home",
          access: user?.modules?.analytics_reporting?.caresms_bi && user?.permissions?.includes('reporting_analytics.caresms_bi.*'),
          disabled: !user?.modules?.analytics_reporting?.caresms_bi || !user?.permissions?.includes('reporting_analytics.caresms_bi.*'),
        },
      ],
    },
    // {
    //   id: 23,
    //   name: "Analytics",
    //   path: "/analytics",
    //   icon: Icons.Stats_Icon,
    //   hasSubsections: true,
    //   access: ["1"],
    //   subSections: [
    //     {
    //       id: 1,
    //       name: "Pivot",
    //       path: "/analytics/pivot",
    //       access: ["*"],
    //     },
    //     {
    //       id: 2,
    //       name: "Dashboard",
    //       path: "/analytics/dashboard",
    //       access: ["*"],
    //     },
    //   ],
    // },
  ];
  return menuOptions;
};


export default useMenuOptions;
